import React from "react";
import PropTypes from 'prop-types';
import SearchComponent from './SearchComponent';
import FilterButtonComponent from '../button/FilterButtonComponent';
import DateComponent from '../input/DateComponent';
import RadioButtonComponent from '../input/RadioButtonComponent';


const FilterBoxComponent = ({
    month_date,
    from_date,
    to_date,
    food_order_type,
    handleClickFilterCloseAction,
    handleMonthDateChange,
    handleFromDateChange,
    handleToDateChange,
    handleOrderType,
    handleClickFilterSubmitAction
}) => {
    return (
        <div className="formBox card_min_heigth500 intercomFormBox" id="formBox">
            <div className="intercomCloseBtn" id="interClose" onClick={handleClickFilterCloseAction}>
                <span onClick={handleClickFilterCloseAction} className="img-responsive lazy">
                    <i className="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>

            {handleMonthDateChange && (
                <div className="flex ml-5 mr-10 pt-10">
                    <DateComponent
                        style="col-md-7 mt-3"
                        input_icon="fontisto:date"
                        input_style="react-datepicker__input-box"
                        label="Month"
                        place_holder="Month"
                        name="month_date"
                        field_name="month_date"
                        type="date"
                        value={month_date}
                        onChange={handleMonthDateChange}
                        display={true}
                    />
                </div>
            )}

            {handleFromDateChange && (
                <div className="flex ml-5 mr-10 pt-10">
                    <DateComponent
                        style="col-md-7 mt-3"
                        input_icon="fontisto:date"
                        input_style="react-datepicker__input-box"
                        label="From Date"
                        place_holder="From Date"
                        name="from_date"
                        type="date"
                        value={from_date}
                        onChange={handleFromDateChange}
                        display={true}
                    />
                    <DateComponent
                        style="col-md-7 mt-3"
                        input_icon="fontisto:date"
                        input_style="react-datepicker__input-box"
                        label="To Date"
                        place_holder="To Date"
                        name="to_date"
                        type="date"
                        value={to_date}
                        onChange={handleToDateChange}
                        display={true}
                    />
                </div>
            )}

            {handleOrderType &&
                <div className="flex ml-5 mr-10 pt-10">
                    <RadioButtonComponent
                        style="col-md-12 mt-3"
                        input_style="form-control"
                        type="text"
                        label="Order Type"
                        placeholder=""
                        name="food_order_type"
                        field_name="food_order_type"
                        value={food_order_type}
                        onChange={handleOrderType}
                        display={true}
                    />
                </div>
            }

            <div className="flex justify-start ml-5 mr-10 pt-10">
                <FilterButtonComponent onClick={handleClickFilterSubmitAction}>
                    Filter
                </FilterButtonComponent>
            </div>
        </div>
    );
};

FilterBoxComponent.propTypes = {
    month_date: PropTypes.string, 
    from_date: PropTypes.string,
    to_date: PropTypes.string,
    food_order_type: PropTypes.string,
    handleClickFilterCloseAction: PropTypes.func,
    handleMonthDateChange: PropTypes.func, 
    handleFromDateChange: PropTypes.func,
    handleToDateChange: PropTypes.func,
    handleOrderType: PropTypes.func,
    handleClickFilterSubmitAction: PropTypes.func
};

export default FilterBoxComponent;
